// filepath: apps/web/src/features/directory/qualifications/QualificationsPage.tsx
//
// FR-UI-DIR-1 AC-8 — qualifications page (per-person drilldown).
//
// F1 FINDING: `/api/directory/qualifications` is NOT shipped yet.
// Per the impact analysis, this page MUST render the fetch-failure
// state immediately and MUST NOT call the missing endpoint. The
// static-guard test in apps/web/src/runtime/staticGuards.test.ts
// asserts no fetch call to /api/directory/qualifications and no
// import of that route.

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

export interface QualificationsPageProps {
  personId: string;
}

export function QualificationsPage({
  personId,
}: QualificationsPageProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <section
      className="directory-qualifications"
      data-testid="qualifications-page"
      data-person-id={personId}
    >
      <header className="directory-qualifications__header">
        <h1>{t("directory.qualifications.title", "Qualifications")}</h1>
      </header>
      <p
        role="alert"
        className="directory-qualifications__fetch-failure"
        data-testid="qualifications-fetch-failure"
      >
        {t("directory.qualifications.deferred.body")}
      </p>
    </section>
  );
}
